







































































































import BaseDialog from '@/components/BaseDialog.vue';
import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';

import { PropType } from 'vue';
import { ValidationRules } from '@/api/schema';
import * as vr from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';
import {
  TAiStreamer,
  TAiStreamerPayload,
  TIMEZONES
} from '@/views/CopyStake/CopyStakeAutoclicker/types';
import { updateAutoclickerConfig } from '@/api/CopyStake/AutoClicker';

import defaultAvatar from '@/assets/images/autoclicker-avatar.png';

interface ActivatorOn {
  click?: (
    event?:
      | MouseEvent
      | { stopPropagation: () => void; preventDefault: () => void }
  ) => void;
}

const DEFAULT_ZONE = 'UTC';

export const startTimeSelectionList = [
  { text: 'Start now', value: 'now' },
  { text: 'Custom time', value: 'custom' }
];

const defaultFormAiStreamerData = (): Partial<TAiStreamer> => {
  return {
    id: null,
    startTime: '',
    startNow: false,
    endTime: '',
    zone: DEFAULT_ZONE
  };
};

export default {
  name: 'CopyStakeAiStreamerPlanModal',
  components: {
    BaseDialog,
    VExtendedDataPicker
  },
  props: {
    form: {
      type: Object as PropType<Partial<TAiStreamer>>,
      default: defaultFormAiStreamerData
    },
    value: {
      type: Boolean,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      defaultAvatar,

      startTimeSelectionList,
      startTimeSelection: null,

      formDataAiStreamer: defaultFormAiStreamerData(),
      isFormPlanAiStreamerValid: true,
      timezoneList: TIMEZONES,

      loading: {
        processing: false
      }
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    formAiStreamerPayload(): TAiStreamerPayload {
      return {
        ...this.formDataAiStreamer,
        startTime: this.formDataAiStreamer.startNow
          ? null
          : this.formDataAiStreamer.startTime + ':00',
        endTime: this.formDataAiStreamer.endTime + ':00'
      };
    },

    dateStreamerNow(): string {
      return DateTime.now()
        .setZone(this.formDataAiStreamer.zone)
        .toFormat('yyyy-MM-dd HH:mm');
    },

    rules(): ValidationRules {
      return {
        startTime:
          this.startTimeSelection === 'now'
            ? [
                () =>
                  vr.required(this.formDataAiStreamer.startTime, 'Start Time')
              ]
            : [
                () =>
                  vr.required(
                    this.formDataAiStreamer.startTime,
                    'Start Time'
                  ),
                () => {
                  const isValid =
                    vr.isDateTimeAfterOrEqual(
                      this.formDataAiStreamer.startTime,
                      this.dateStreamerNow
                    ) === true &&
                    vr.isDateNotEqual(
                      this.formDataAiStreamer.startTime,
                      this.dateStreamerNow
                    ) === true;

                  return isValid === true
                    ? true
                    : 'Start date must be in the future';
                }
              ],
        endTime:
          this.startTimeSelection === 'now'
            ? [
                (v: string) => vr.required(v, 'End Time'),
                (v) => vr.isDateNotEqual(v, this.dateStreamerNow),
                (v) => vr.isDateTimeAfterOrEqual(v, this.dateStreamerNow)
              ]
            : [
                (v: string) => vr.required(v, 'End Time'),
                (v) =>
                  vr.isDateNotEqual(v, this.formDataAiStreamer.startTime),
                (v) =>
                  vr.isDateTimeAfterOrEqual(
                    v,
                    this.formDataAiStreamer.startTime
                  )
              ],
        zone: [(v: string) => vr.required(v, 'Timezone')]
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetAiStreamerForm();

      if (!open) {
        return;
      }

      this.formDataAiStreamer = {
        ...this.form,
        startTime: this.form?.startTime?.slice(0, 16) || '',
        endTime: this.form?.endTime?.slice(0, 16) || ''
      };

      if (this.form.startTime) {
        this.startTimeSelection = 'custom';
      }
    },
    'formDataAiStreamer.zone'(): void {
      this.validateDate('startTime');
      this.validateDate('endTime');
    },
    'formDataAiStreamer.startTime'(): void {
      this.validateDate('endTime');
    },
    'formDataAiStreamer.endTime'(): void {
      this.validateDate('startTime');
    }
  },
  methods: {
    selectStartTimeHandler(value: string, on: ActivatorOn): void {
      this.startTimeSelection = value;
      this.$refs.startTime?.blur();

      if (value === 'now') {
        this.formDataAiStreamer.startTime = 'Start now';
        this.formDataAiStreamer.startNow = true;
      }

      if (value === 'custom' && on && typeof on.click === 'function') {
        this.formDataAiStreamer.startNow = false;

        on.click({
          stopPropagation: () => undefined,
          preventDefault: () => undefined
        });
      }
    },
    async resetAiStreamerForm(): Promise<void> {
      await this.$refs.aiStreamerPlanForm?.reset();

      this.formDataAiStreamer = {
        ...this.formDataAiStreamer,
        ...defaultFormAiStreamerData()
      };
    },
    validateDate(type: string): void {
      if (this.formDataAiStreamer[type]?.length !== 0) {
        this.$nextTick(() => {
          this.$refs[type].validate();
        });
      }
    },

    async handleSubmit(): Promise<void> {
      this.isFormPlanAiStreamerValid =
        await this.$refs.aiStreamerPlanForm.validate();

      if (!this.isFormPlanAiStreamerValid || this.loading.processing) return;

      this.loading.processing = true;

      updateAutoclickerConfig(this.formAiStreamerPayload)
        .then(() => {
          this.$toast.success('AI Streamer Config updated');
          this.$emit('update');
          this.closeModal();
        })
        .catch(errorToastMessage)
        .finally(() => {
          this.loading.processing = false;
        });
    },
    closeModal(): void {
      this.$emit('input', false);
    }
  }
};
